module.exports = __webpack_public_path__ + "img/583-42dfb3.png";